/* ------------------------------------------------------------------
 * Save Max Auto homepage variation.
 *
 * Ported from sma-shop-variation/app.js. Two things changed in the move
 * to Shopify:
 *
 *   1. Package data is no longer a literal in this file. Each package
 *      button carries the live product's title, price, multiplier and
 *      variant id in data attributes, so the dialog reads whatever the
 *      store currently sells.
 *   2. Every section can be removed or disabled in the theme editor, so
 *      each feature checks for its own markup and binds independently.
 *      init() is idempotent and re-runs on shopify:section:load.
 * ------------------------------------------------------------------ */
(function () {
  'use strict';

  var BOUND = 'smaBound';

  function once(element) {
    if (!element || element.dataset[BOUND] === 'true') return false;
    element.dataset[BOUND] = 'true';
    return true;
  }

  function getCookie(name) {
    var match = document.cookie.match('(^|;)\\s*' + name + '\\s*=\\s*([^;]+)');
    return match ? decodeURIComponent(match.pop()) : '';
  }

  /* ---------------------------------------------------------- header */

  function initHeader() {
    var menuToggle = document.querySelector('.sma-scope .menu-toggle');
    var mobileNav = document.querySelector('.sma-scope #mobile-nav');
    if (!menuToggle || !mobileNav || !once(menuToggle)) return;

    function closeMenu(restoreFocus) {
      mobileNav.hidden = true;
      menuToggle.setAttribute('aria-expanded', 'false');
      if (restoreFocus) menuToggle.focus();
    }

    menuToggle.addEventListener('click', function () {
      var expanded = menuToggle.getAttribute('aria-expanded') === 'true';
      menuToggle.setAttribute('aria-expanded', String(!expanded));
      mobileNav.hidden = expanded;
    });
    mobileNav.addEventListener('click', function (event) {
      if (event.target.closest('a, button')) closeMenu(false);
    });
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && !mobileNav.hidden) closeMenu(true);
    });
    document.addEventListener('click', function (event) {
      if (!mobileNav.hidden && !event.target.closest('.site-header')) closeMenu(false);
    });
    window.matchMedia('(min-width: 768px)').addEventListener('change', function (event) {
      if (event.matches) closeMenu(false);
    });
  }

  /* -------------------------------------------------- package dialog */

  function closesOnBackdrop(dialog, onClose) {
    dialog.addEventListener('click', function (event) {
      if (event.target !== dialog) return;
      var box = dialog.getBoundingClientRect();
      var outside =
        event.clientX < box.left ||
        event.clientX > box.right ||
        event.clientY < box.top ||
        event.clientY > box.bottom;
      if (outside) onClose();
    });
  }

  function initPackages() {
    var dialog = document.querySelector('#package-dialog');
    if (!dialog || !once(dialog)) return;

    var lastPackageButton;

    document.querySelectorAll('.package-select').forEach(function (button) {
      button.addEventListener('click', function () {
        var data = button.dataset;
        lastPackageButton = button;

        dialog.querySelector('#dialog-title').textContent = data.dialogTitle;
        dialog.querySelector('#dialog-entries').textContent = data.entries + ' entries';
        dialog.querySelector('#dialog-price').textContent = data.price;
        dialog.querySelector('#dialog-formula').textContent =
          data.base + ' base entries × ' + data.multiplier + ' bonus multiplier';

        // The includes list is rendered by Liquid into a hidden template
        // beside the button, so no product copy is built in JavaScript.
        var includes = button.parentElement.querySelector('.package-includes ul');
        var target = dialog.querySelector('#dialog-includes');
        target.replaceChildren();
        if (includes) {
          includes.querySelectorAll('li').forEach(function (item) {
            var li = document.createElement('li');
            li.textContent = item.textContent.trim();
            target.appendChild(li);
          });
        }

        var cta = dialog.querySelector('#dialog-continue');
        if (data.variant) cta.href = window.Shopify.routes.root + 'cart/' + data.variant + ':1';
        cta.hidden = !data.variant;

        dialog.showModal();
        document.body.style.overflow = 'hidden';
      });
    });

    dialog.querySelector('.dialog-close').addEventListener('click', function () {
      dialog.close();
    });
    closesOnBackdrop(dialog, function () {
      dialog.close();
    });
    dialog.addEventListener('close', function () {
      document.body.style.overflow = '';
      if (lastPackageButton) lastPackageButton.focus();
    });
  }

  /* --------------------------------------------------- truck gallery */

  function initGallery() {
    var galleryImage = document.querySelector('#gallery-image');
    var galleryCaption = document.querySelector('#gallery-caption');
    var galleryLoading = document.querySelector('.gallery-loading');
    if (!galleryImage || !once(galleryImage)) return;

    var galleryRequest = 0;
    var thumbs = document.querySelectorAll('.gallery-thumb');

    thumbs.forEach(function (button) {
      button.addEventListener('click', function () {
        var request = ++galleryRequest;
        if (galleryLoading) galleryLoading.hidden = false;

        var next = new Image();
        next.src = button.dataset.image;
        next
          .decode()
          .then(function () {
            if (request !== galleryRequest) return;
            galleryImage.src = next.src;
            if (button.dataset.srcset) galleryImage.srcset = button.dataset.srcset;
            galleryImage.alt = button.dataset.description;
            galleryCaption.textContent = button.dataset.description;
            thumbs.forEach(function (thumb) {
              thumb.setAttribute('aria-pressed', String(thumb === button));
            });
          })
          .catch(function () {
            if (request === galleryRequest) {
              galleryCaption.textContent = 'We couldn’t load this photo. Please try again.';
            }
          })
          .finally(function () {
            if (request === galleryRequest && galleryLoading) galleryLoading.hidden = true;
          });
      });
    });
  }

  /* --------------------------------------------------- shop filters */

  function initFilters() {
    var group = document.querySelector('.product-filters');
    if (!group || !once(group)) return;

    var buttons = group.querySelectorAll('[data-filter]');
    var status = document.querySelector('#filter-status');

    buttons.forEach(function (button) {
      button.addEventListener('click', function () {
        buttons.forEach(function (filter) {
          filter.setAttribute('aria-pressed', String(filter === button));
        });

        var wanted = button.dataset.filter;
        var count = 0;
        document.querySelectorAll('.product-grid .product').forEach(function (product) {
          // A product can sit in several categories, so the attribute is a
          // space-separated list rather than a single value.
          var categories = (product.dataset.category || '').split(' ');
          product.hidden = wanted !== 'all' && categories.indexOf(wanted) === -1;
          if (!product.hidden) count++;
        });

        if (status) {
          status.textContent = 'Showing ' + count + ' products: ' + button.textContent.trim() + '.';
        }
      });
    });
  }

  /* ------------------------------------------------ mobile entry bar */

  function initStickyEntry() {
    var stickyEntry = document.querySelector('.mobile-entry-bar');
    if (!stickyEntry || !once(stickyEntry)) return;

    var hero = document.querySelector('.hero');
    var entrySection = document.querySelector('#entry-options');
    var footer = document.querySelector('.site-footer');
    var watched = [hero, entrySection, footer].filter(Boolean);
    if (!watched.length) return;

    var heroPassed = false;
    var entryVisible = false;
    var footerVisible = false;

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.target === hero) {
            heroPassed = !entry.isIntersecting && entry.boundingClientRect.bottom < 0;
          }
          if (entry.target === entrySection) entryVisible = entry.isIntersecting;
          if (entry.target === footer) footerVisible = entry.isIntersecting;
        });
        stickyEntry.hidden = !heroPassed || entryVisible || footerVisible;
      },
      { threshold: 0 }
    );
    watched.forEach(function (element) {
      observer.observe(element);
    });
  }

  /* ------------------------------------------- guest free-entry invite */

  function initFreeOptions() {
    var freeOptionsDialog = document.querySelector('#free-options-dialog');
    if (!freeOptionsDialog || !once(freeOptionsDialog)) return;

    var settings = freeOptionsDialog.dataset;
    var IDLE_DELAY = Number(settings.idleDelay || 30) * 1000;
    var DISMISS_DURATION = Number(settings.dismissDays || 7) * 24 * 60 * 60 * 1000;
    var SEEN_KEY = 'sma:free-options:seen';
    var DISMISSED_KEY = 'sma:free-options:dismissed-until';
    var REGISTER_KEY = 'sma:free-options:registration-started';

    var idleTimer;
    var seenThisPage = false;
    var previousFocus;
    var previousOverflow = '';
    var invitationActive = false;

    function read(storageName, key) {
      try {
        return window[storageName].getItem(key);
      } catch (error) {
        return null;
      }
    }
    function write(storageName, key, value) {
      try {
        window[storageName].setItem(key, value);
      } catch (error) {
        /* In-memory frequency cap still applies. */
      }
    }
    function suppressed() {
      return (
        document.body.dataset.customerState === 'registered' ||
        seenThisPage ||
        read('sessionStorage', SEEN_KEY) === '1' ||
        read('sessionStorage', REGISTER_KEY) === '1' ||
        Number(read('localStorage', DISMISSED_KEY)) > Date.now()
      );
    }
    function visitorIsBusy() {
      var menuToggle = document.querySelector('.sma-scope .menu-toggle');
      return (
        document.hidden ||
        Boolean(document.querySelector('dialog[open]')) ||
        Boolean(document.querySelector('.menu-drawer-container details[open]')) ||
        (menuToggle && menuToggle.getAttribute('aria-expanded') === 'true') ||
        Boolean(
          document.activeElement &&
            document.activeElement.closest(
              'input, textarea, select, [contenteditable]:not([contenteditable="false"])'
            )
        )
      );
    }
    function show(manual) {
      if (visitorIsBusy() || (!manual && suppressed())) return;
      clearTimeout(idleTimer);
      previousFocus = document.activeElement;
      previousOverflow = document.body.style.overflow;
      invitationActive = true;
      freeOptionsDialog.showModal();
      document.body.style.overflow = 'hidden';
      seenThisPage = true;
      write('sessionStorage', SEEN_KEY, '1');
    }
    function schedule() {
      clearTimeout(idleTimer);
      if (suppressed() || visitorIsBusy()) return;
      idleTimer = setTimeout(function () {
        show(false);
      }, IDLE_DELAY);
    }
    function restore() {
      if (!invitationActive) return;
      invitationActive = false;
      clearTimeout(idleTimer);
      write('localStorage', DISMISSED_KEY, String(Date.now() + DISMISS_DURATION));
      document.body.style.overflow = previousOverflow;
      if (previousFocus instanceof HTMLElement && previousFocus.isConnected) {
        previousFocus.focus({ preventScroll: true });
      }
    }
    function close(reason) {
      freeOptionsDialog.close(reason || 'dismiss');
      // Restore immediately even if the browser defers the native close event.
      restore();
    }

    // Wheel/touch/keyboard/pointer activity resets the timer; background tabs
    // never trigger it.
    ['pointermove', 'pointerdown', 'keydown', 'wheel', 'touchmove', 'focusin', 'focusout'].forEach(
      function (event) {
        document.addEventListener(event, schedule, { passive: true });
      }
    );
    document.addEventListener('visibilitychange', schedule);
    window.addEventListener('pageshow', schedule);
    window.addEventListener('pagehide', function () {
      clearTimeout(idleTimer);
    });
    window.addEventListener('storage', schedule);

    // A newly opened menu/dialog cancels the countdown immediately,
    // including scripted opens.
    var reminderObserver = new MutationObserver(schedule);
    var packageDialog = document.querySelector('#package-dialog');
    if (packageDialog) {
      packageDialog.addEventListener('close', schedule);
      reminderObserver.observe(packageDialog, { attributes: true, attributeFilter: ['open'] });
    }
    var menuToggle = document.querySelector('.sma-scope .menu-toggle');
    if (menuToggle) {
      reminderObserver.observe(menuToggle, { attributes: true, attributeFilter: ['aria-expanded'] });
    }
    reminderObserver.observe(document.body, {
      attributes: true,
      attributeFilter: ['data-customer-state'],
    });

    freeOptionsDialog.querySelectorAll('[data-dismiss-free-options]').forEach(function (button) {
      button.addEventListener('click', function () {
        close();
      });
    });
    closesOnBackdrop(freeOptionsDialog, function () {
      close();
    });
    freeOptionsDialog.addEventListener('cancel', function (event) {
      event.preventDefault();
      close();
    });
    freeOptionsDialog.addEventListener('close', restore);

    var register = document.querySelector('#free-options-register');
    if (register) {
      register.addEventListener('click', function () {
        // Records only a handoff, never a successful registration or entry.
        write('sessionStorage', REGISTER_KEY, '1');
        close('registration');
      });
    }
    var rules = document.querySelector('.free-options-rules');
    if (rules) {
      rules.addEventListener('click', function () {
        close('rules');
      });
    }
    document.querySelectorAll('[data-open-free-options]').forEach(function (button) {
      button.addEventListener('click', function () {
        show(true);
      });
    });

    // Review-only URL: /?preview=free-options.
    if (new URLSearchParams(window.location.search).get('preview') === 'free-options') show(true);
    else schedule();
  }

  /* -------------------------------------- free entry registration step */

  function initEntryRegistration() {
    var dialog = document.querySelector('#entry-registration-dialog');
    if (!dialog || !once(dialog)) return;

    var form = dialog.querySelector('.entry-registration-form');
    var field = dialog.querySelector('#entry-registration-email');
    var error = dialog.querySelector('#entry-registration-error');
    var submit = form.querySelector('[type="submit"]');
    var previousFocus;
    var previousOverflow = '';
    var handingOff = false;

    function showError(message) {
      error.textContent = message;
      error.hidden = false;
      field.setAttribute('aria-invalid', 'true');
      field.focus();
    }
    function clearError() {
      error.hidden = true;
      error.textContent = '';
      field.removeAttribute('aria-invalid');
    }

    function open() {
      if (dialog.open) return;
      // Only one modal at a time - the invitation, if it is up, steps aside.
      document.querySelectorAll('dialog[open]').forEach(function (other) {
        other.close();
      });
      previousFocus = document.activeElement;
      previousOverflow = document.body.style.overflow;
      clearError();
      dialog.showModal();
      document.body.style.overflow = 'hidden';
      field.focus({ preventScroll: true });
      field.select();
    }

    dialog.addEventListener('close', function () {
      document.body.style.overflow = previousOverflow;
      // A hand-off is navigating away; moving focus then only flickers.
      if (handingOff) return;
      if (previousFocus instanceof HTMLElement && previousFocus.isConnected) {
        previousFocus.focus({ preventScroll: true });
      }
    });

    dialog.querySelectorAll('[data-close-entry-registration]').forEach(function (button) {
      button.addEventListener('click', function () {
        dialog.close();
      });
    });
    closesOnBackdrop(dialog, function () {
      dialog.close();
    });

    field.addEventListener('input', clearError);

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      if (handingOff) return;

      var email = field.value.trim();
      field.value = email;
      if (!email || !field.checkValidity()) {
        showError('Enter a valid email address so we can start your free entries.');
        return;
      }

      // The portal owns the rest of registration; the storefront stores
      // nothing and only passes the address along.
      var portal;
      try {
        portal = new URL(dialog.dataset.finalizeUrl, window.location.href);
      } catch (urlError) {
        showError('We couldn’t open the entry portal. Please try again later.');
        return;
      }
      portal.searchParams.set('email', email);

      // pfm-track.js (rendered in <head>) attributes the visit and stores
      // this cookie; forward it so the portal can keep the attribution.
      var clickId = (window.pfm && window.pfm.identity && window.pfm.identity().click_id) || getCookie('clickId');
      if (clickId) portal.searchParams.set('clickId', clickId);

      handingOff = true;
      submit.disabled = true;
      form.setAttribute('aria-busy', 'true');
      window.location.assign(portal.toString());
    });

    // Delegated so buttons in sections re-rendered by the theme editor,
    // and any added later, open the dialog without rebinding.
    document.addEventListener('click', function (event) {
      var trigger = event.target.closest && event.target.closest('[data-open-entry-registration]');
      if (!trigger) return;
      event.preventDefault();
      open();
    });
  }

  /* -------------------------------------------------------------- run */

  function init() {
    initHeader();
    initPackages();
    initGallery();
    initFilters();
    initStickyEntry();
    initFreeOptions();
    initEntryRegistration();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Theme editor: a re-rendered section arrives unbound.
  document.addEventListener('shopify:section:load', init);
})();
